
namespace TabAurous.Sales {
  
    @Serenity.Decorators.registerClass()
    export class ApprovalReturnGrid extends Serenity.EntityGrid<ApprovalOutReturnRow, any> {
        protected getColumnsKey() { return 'Sales.ApprovalOutReturn'; }
        protected getDialogType() { return ApprovalOutReturnDialog; }
        protected getIdProperty() { return ApprovalOutReturnRow.idProperty; }
        protected getInsertPermission() { return ApprovalOutReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalOutReturnRow.localTextPrefix; }
        protected getService() { return ApprovalOutReturnService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.setTitle("");
        }
        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service: 'Sales/ApprovalOutReturn/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true


                },
                field: 'PartyId',
                title: 'Customer',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }
        onViewProcessData(response: Serenity.ListResponse<ApprovalOutRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new Reports.LineChartPanel(this.chartContainer, { items: response.Entities });
             

            return response;
        }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push({

            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Reports.ApprovalRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //});
            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                title: "Print",
                reportTitle: "Sales Consignment Return",
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}